<template>
<div class="tab-wrapper">
  <h3 class="mb16">物业交割清单</h3>
  <div class="content" >
    <div class="item pt16 pb16">
      <table-list :columns="columns" :total="total" @change-page="changPage" :data="deliverysInfo" :loading="loading"></table-list>
    </div>
  </div>
  <delivery-modal  :n="key" @showimg="showImg" :deliverysInfo="subDeliverysInfo" :houseNumber="houseNumber"></delivery-modal>
  <img-show :n="showImgKey" :src="imgSrc"></img-show>
</div>
</template>

<script type="text/ecmascript-6">
import { getEnterpriseDeliverys, getSurrenderDeliverys } from 'api/termination'
// import defaultImg from '@/assets/filedefault.jpg'
import TableList from "components/TableList/index"
import DeliveryModal from "./CompanyDeliveryModal"
import ImgShow from 'components/ImgShow/index'

export default {
  created(){
    this.getEnterpriseDeliverys(1)
  },
  props:{
    surrenderFid:{
      type:String,
      default:''
    },
    parentSurrenderFid:{
      type:String,
      default:''
    },
    contractFid:{
      type:String,
      default:''
    },
    n:{
      type:Number,
      default:0
    }
  },
  watch:{
    n(){
      this.getEnterpriseDeliverys(1)
    }
  },
components:{
  TableList,
  DeliveryModal,
  ImgShow
},
 data () {
  return {
    current:1,
    total:0,
    deliverysInfo:[],
    houseNumber:'',
    imgSrc:'',
    showImgKey:0,
    key:0,
    subDeliverysInfo:null,
    roomFid:'',
    // defaultImg:defaultImg,
    loading:false,
    priceLoading:false,
    goodsLoading:false,
    columns:[
      {
        type: "index",
        width:60,
        align: "center"
      },
      {
        title: "房间号",
        key: "houseNumber",
        align: "center"
      },
      {
        title: "交割状态",
        key: "deliveryName",
        align: "center"
      },
      {
        title: "操作",
        key: "attachment",
        align: "center",
        render: (h,params) => {
          return h('a',{
            style:{
              color: '#CFA868',
              cursor: 'pointer'
            },
            on: {
              click: ()=>{
                // 调接口
                this.contractFid=params.row.contractFid
                this.houseNumber =params.row.houseNumber
                let deliveryParams = {
                  contractFid:params.row.contractFid,
                  surrenderFid:params.row.surrenderFid
                }

                getSurrenderDeliverys(deliveryParams).then( res => {
                  this.subDeliverysInfo = res.data
                })
                this.key++
                // this.$emit('showimg', params.row.attachment)
              }
            }
          },'查看')
        }
      }
    ]
  };
 },
 methods:{
   showImg(data) {
      this.imgSrc = data
      this.showImgKey++
    },
    getEnterpriseDeliverys(page){
      let params = {
        page:page,
        limit:10,
        surrenderFid:this.surrenderFid,
        parentSurrenderFid:this.parentSurrenderFid,
        contractFid:this.contractFid
      }
      getEnterpriseDeliverys(params).then( res => {
        this.deliverysInfo = res.data.enterpriseDeliveryDto
        this.total = res.data.total
        this.loading = false
      })
    },
    changPage(n){
      this.current = n;
      this.getBalanceInfo(n)
    },

 }
}
</script>




